import CustomTags from '../customfields/CustomTags.jsx';
import { ObjectTypes } from '../../lib/ObjectTypes.js';

const ClientListItem = ({
    client,
    onClick,
    isFirst,
    isSelected,
    footerContent,
}) => {
    return (
        <div
            className={`${isFirst ? '' : 'border-t'} py-4 cursor-pointer group flex items-center justify-between client-list-item`}
            onClick={onClick}
        >
            <div>
                <div
                    className={`text-lg group-hover:text-primary-700 ${isSelected ? 'text-primary-700' : ''}`}
                >
                    {!!client.last_name && `${client.last_name},`}{' '}
                    {client.first_name}
                </div>
                <div className="text-gray-500 text-sm">{client.email}</div>
                {footerContent}
            </div>
            <div className="mr-4">
                <CustomTags
                    type={ObjectTypes.CLIENT}
                    fields={client.custom_fields}
                />
            </div>
        </div>
    );
};

export default ClientListItem;
